import { Outlet, createBrowserRouter, redirect } from 'react-router';
import { Error404, Loader } from 'ui-components';
import React from 'react';
import { ReferralLayout } from 'referral/components';
import { ReferralInvitation, ReferralRedemption, Review } from './routes';

export default createBrowserRouter([
  {
    element: (
      <ReferralLayout src="/images/referral-bg.jpg">
        <React.Suspense fallback={<Loader />}>
          <Outlet />
        </React.Suspense>
      </ReferralLayout>
    ),
    children: [
      {
        path: '/invite/:code',
        element: <ReferralInvitation />,
      },
      {
        path: '/referral/:code',
        element: <ReferralRedemption />,
      },
      {
        path: '/review/:bookingUid',
        element: <Review />,
      },
      {
        // Redirect from /i/:code to /invite/:code
        path: '/i/:code',
        loader: ({ params }) => {
          return redirect(`/invite/${params.code}`);
        },
      },
    ],
  },
  {
    path: '/not-found',
    element: <Error404 />,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);
